<template>
  <b-card title="List Item">
    <b-col cols="12">
      <b-row class="mb-2">
        <b-col md="4" cols="12">
          <b-form-select
            v-model="type"
            label="Type"
            type="search"
            :options="typeOption"
            @input="reFetch"
          />
        </b-col>
        <b-col cols="4" />
        <b-col md="4" cols="12">
          <b-form-input
            v-model="search"
            @input="(value) => doFiltering(value)"
            type="search"
            placeholder="Type to Search"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
            :items="items"
            :fields="fields"
            :busy.sync="tableLoading"
            show-empty
          >
            <template #cell(actions)="row">
              <b-dropdown
                id="dropdown-dropleft"
                variant="primary"
                size="sm"
                text="Menu"
                no-caret
              >
                <template #button-content>
                  <feather-icon size="1x" icon="MenuIcon" />
                </template>

                  <b-dropdown-item style="text-align:center">
                    <b-button
                      @click="toDetailItem(row)"
                      class="mr-1"
                      variant="info"
                    >
                      <feather-icon icon="EyeIcon" />
                    </b-button>
                  </b-dropdown-item>
                  <b-dropdown-item style="text-align:center">
                    <b-button
                      @click="toEditItem(row)"
                      class="mr-1"
                      variant="info"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-dropdown-item>

              </b-dropdown>
              
            </template>

            <template #cell(status)="row">
              {{ row.item.status === "" ? "Active" : "Inactive" }}
            </template>
          </b-table>
        </b-col>

        <b-col cols="12">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            @change="onPageChange"
            v-model="currentPage"
            style="float: right"
            first-number
            last-number
          />
        </b-col>
      </b-row>
    </b-col>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import lodash from "lodash";

export default {
  data() {
    return {
      fields: [
        {
          key: "itemModel",
          label: "Item Model",
          filterable: true,
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          filterable: true,
          sortable: true,
        },
        // { key: 'price', label: 'Price', filterable: true, filterable: true, sortable: true },
        // { key: 'pointIssued', label: 'Point Issued'},
        { key: "status", label: "Status", filterable: true, sortable: true },
        { key: "actions", label: "Action" },
      ],
      row: 0,
      search: "",
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      tableLoading: true,
      showSpinner: false,
      tempMetadata: "",
      type: "sparepart",
      typeOption: [
        { value: "sparepart", text: "Sparepart" },
        { value: "accessories", text: "Accessories" },
        { value: "air-purifier", text: "Air Purifier" },
      ]
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      getItems: "item/getItemsWithFilter",
    }),
    reFetch () {
      this.getItems({
      page: this.currentPage,
      entry: this.perPage,
      description: this.search,
      type: this.type
      }).then((data) => this.processMetadata(data.metadata));  
    },
    doFiltering: lodash.debounce(function(value) {
      this.search = value;
      this.currentPage = 1;
      this.queryItem();
    }, 500),
    queryItem() {
      this.getItems({
        page: this.currentPage,
        entry: this.perPage,
        description: this.search,
        type: this.type,
      }).then((metadata) => {
        this.processMetadata(metadata.metadata);
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.queryItem()
    },
    processMetadata(metadata) {
      let { totalData } = metadata;
      this.totalRows = totalData;
      this.tableLoading = false;
    },
    toDetailItem(row) {
      this.$router.push(`/sparepart-master/view/${row.item._id}`);
    },
    toEditItem(row) {
      this.$router.push(`/sparepart-master/edit/${row.item._id}`);
    },
  },
  computed: {
    ...mapGetters({
      items: "item/items",
    }),
  },
  mounted() {
    const toastMsg = sessionStorage.getItem("toastMessage");
    if (toastMsg) {
      this.$bvToast.toast(toastMsg, {
        title: "Success",
        variant: "success",
        solid: true,
      });
      sessionStorage.removeItem("toastMessage"); // agar tidak muncul lagi saat reload
    }

    const toastMsgError = sessionStorage.getItem("toastMessageError");
    if (toastMsgError) {
      this.$bvToast.toast(toastMsgError, {
        title: "Failed",
        variant: "danger",
        solid: true,
      });
      sessionStorage.removeItem("toastMessageError"); // agar tidak muncul lagi saat reload
    }
    this.getItems({
      page: this.currentPage,
      entry: this.perPage,
      type: this.type
    }).then((data) => this.processMetadata(data.metadata));  
  },
  created() {
    document.title = "Sparepart Item | RSP";
  },
};
</script>
<style scoped>
  .dropdown-show{
    overflow-y: auto;
    height: 80px;
  }
</style>